import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaEnvelope, FaHeadset, FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "Product",
      links: [
        { label: "Solar Panels", url: "/solar-panel" },
        { label: "Battery Storage", url: "/battery" },
        { label: "Smart Monitoring", url: "/monitoring" },
        { label: "Maintenance", url: "/maintenance" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "About Us", url: "/aboutus" },
        { label: "Contact", url: "/contact" },
      ],
    },
  ];

  return (
    <footer className="relative text-white overflow-hidden">

      {/* BACKGROUND */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-md" />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(120deg, rgba(0,0,0,0.9), rgba(249,122,8,0.25))",
        }}
      />

      {/* 🔥 TOP CONTACT BAR */}
{/* 🔥 TOP CONTACT BAR */}
<div className="relative z-10 border-b border-white/10 py-6 px-6 max-w-7xl mx-auto grid md:grid-cols-3 gap-6 text-sm">

  {/* Email */}
  <div className="flex items-center gap-4">
    <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-orange-400 text-xl">
      <FaEnvelope />
    </div>
    <div>
      <p className="text-orange-400 font-semibold">Support & Email</p>
      <p className="text-white/70">info@solidera-energy.com</p>
    </div>
  </div>

  {/* Customer Support */}
  <div className="flex items-center gap-4">
    <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-orange-400 text-xl">
      <FaHeadset />
    </div>
    <div>
      <p className="text-orange-400 font-semibold">Customer Support</p>
      <p className="text-white/70">03337111075</p>
    </div>
  </div>

  {/* Sales */}
  <div className="flex items-center gap-4">
    <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-orange-400 text-xl">
      <FaPhoneAlt />
    </div>
    <div>
      <p className="text-orange-400 font-semibold">Sales Inquiry</p>
      <p className="text-white/70">03337111075</p>
    </div>
  </div>

</div>
      {/* 🔥 MAIN FOOTER */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">

        {/* BRAND */}
        <div>
          <img src="/assets/logo.png" alt="Solar company logo" className="h-12 mb-4" />
          <p className="text-white/60 text-sm mb-4">
            Innovative solar solutions for a sustainable future.
          </p>

          {/* SOCIAL */}
          <div className="flex gap-3">
            <motion.a
              href="https://www.facebook.com/profile.php?id=61574004411820"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              className="w-10 h-10 rounded-full bg-orange-500/20 border border-orange-500/50 flex items-center justify-center text-orange-400"
            >
              <FaFacebookF />
            </motion.a>

            <motion.a
              href="https://www.instagram.com/solid_era_energy/"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              className="w-10 h-10 rounded-full bg-orange-500/20 border border-orange-500/50 flex items-center justify-center text-orange-400"
            >
              <FaInstagram />
            </motion.a>

            <motion.a
              href="https://wa.me/923337111075"
              target="_blank"
              whileHover={{ scale: 1.2 }}
              className="w-10 h-10 rounded-full bg-green-500/20 border border-green-500/50 flex items-center justify-center text-green-400"
            >
              <FaWhatsapp />
            </motion.a>
          </div>
        </div>

        {/* LINKS */}
        <div className="grid grid-cols-2 gap-6">
          {footerLinks.map((section, i) => (
            <div key={i}>
              <h3 className="text-white font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <Link
                      to={link.url}
                      className="text-white/60 hover:text-orange-400 text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* MAP / EXTRA (OPTIONAL SECTION) */}
        <div className="hidden md:block">
          <iframe
            title="map"
            src="https://maps.google.com/maps?q=sukkur&t=&z=10&ie=UTF8&iwloc=&output=embed"
            className="w-full h-48 rounded-xl border border-orange-500/20"
          />
        </div>

      </div>

      {/* 🔥 BOTTOM */}
      <div className="relative z-10 border-t border-white/10 py-6 px-6 max-w-7xl mx-auto flex flex-col md:flex-row justify-between text-white/60 text-sm">
        <p>© {currentYear} Solid ERA Energy. All rights reserved.</p>
        <p>
          Solar Website Development & SEO by{" "}

          <a  href="https://mzrsoftware.com"
  target="_blank"
  rel="noopener noreferrer"
    title="ERP, POS & Web Development Company in Pakistan" className="text-orange-400">
            MZR Software
          </a>
        </p>
      </div>

    </footer>
  );
}